module.exports = __webpack_public_path__ + "img/security.d701a885.jpg";